import { updateObject } from "../../shared/utility";
import { globalConstants } from "../../constants";

const {
  SPINNER_ACTIVATE,
  SPINNER_DEACTIVATE,
  GLOBAL_SPINNER_ACTIVATE,
  GLOBAL_SPINNER_DEACTIVATE,
  BUTTON_SPINNER_ACTIVATE,
  BUTTON_SPINNER_DEACTIVATE,
} = globalConstants;

const initialState = {
  spinnerActions: [],
  isSpinnerActivate: false,
  globalSpinnerActivate: false,
  buttonSpinnerActivate: false,
};

const System = (state = initialState, action) => {
  switch (action.type) {
    case SPINNER_ACTIVATE:
      if (!Array.isArray(state.spinnerActions)) {
        return { ...state, spinnerActions: [], isSpinnerActivate: false };
      }
      return updateObject(state, {
        spinnerActions: [...state.spinnerActions, action.data],
        isSpinnerActivate: true,
      });
    case SPINNER_DEACTIVATE:
      return updateObject(state, {
        spinnerActions: [],
        isSpinnerActivate: false,
      });
    case GLOBAL_SPINNER_ACTIVATE:
      return {
        ...state,
        globalSpinnerActivate: true,
      };
    case GLOBAL_SPINNER_DEACTIVATE:
      return {
        ...state,
        globalSpinnerActivate: false,
      };
    case BUTTON_SPINNER_ACTIVATE:
      return {
        ...state,
        buttonSpinnerActivate: true,
      };
    case BUTTON_SPINNER_DEACTIVATE:
      return {
        ...state,
        buttonSpinnerActivate: false,
      };
    default:
      return state;
  }
};
export default System;
